import React, {useState} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import IconLabel from "./IconLabel";
import QrCode from "./QrCode";
import {CheckIcon, CopyIcon, XIcon} from "./icons";

/**
 * The Pix code as a QR code to be read with a phone's camera or bank app, with
 * a button to copy the same code instead.
 *
 * @param {{payload: string, onClose: () => void, hint: string}} props `hint` says what to do with it
 * (the provider shows it to the customer; the customer reads it themselves)
 */
const PixQrModal = ({payload, onClose, hint}) => {
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(payload);
            setCopied(true);
        } catch {
            // No clipboard here: the QR code is the way.
        }
    };

    return (
        <Modal isOpen toggle={onClose} fade={false} centered size="sm">
            <ModalHeader toggle={onClose}>QR code Pix</ModalHeader>
            <ModalBody className="text-center">
                <QrCode value={payload} label="QR code Pix" />
                <p className="text-muted small mt-2 mb-0">{hint}</p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={onClose}>
                    <IconLabel icon={<XIcon />}>Fechar</IconLabel>
                </Button>
                <Button color="primary" onClick={copy}>
                    {copied ? (
                        <IconLabel icon={<CheckIcon />}>Copiado!</IconLabel>
                    ) : (
                        <IconLabel icon={<CopyIcon />}>Copiar código</IconLabel>
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PixQrModal;
